<template>
  <div class="container-fluid mt-4">
    <loading :active.sync="cargando" :can-cancel="false" color="#27884d" :is-full-page="true"></loading>

    <div style="max-width: 900px; margin: 0 auto;">
      <h2 style="font-size: 20px; font-weight: 600; color: #32325d; margin-bottom: 16px;">
        Auditorías realizadas
      </h2>

      <div v-if="error" style="background:#fff; border:1px solid #ffeaea; border-radius:12px; padding:20px; color:#c0002a; font-size:14px;">
        {{ error }}
      </div>

      <template v-else>
        <div style="display:flex; gap:8px; flex-wrap:wrap; margin-bottom:16px;">
          <input
            v-model="busqueda"
            type="text"
            placeholder="Buscar por código..."
            style="font-size:14px; padding:9px 12px; border-radius:8px; border:1px solid #e9ecef;"
          />

          <select v-model="tipoActivo" style="font-size:14px; padding:9px 12px; border-radius:8px; border:1px solid #e9ecef; color:#525f7f;">
            <option value="">Todos los tipos</option>
            <option value="daily">Daily</option>
            <option value="franquicias">Franquicia</option>
          </select>

          <select v-model="escalaActiva" style="font-size:14px; padding:9px 12px; border-radius:8px; border:1px solid #e9ecef; color:#525f7f;">
            <option value="">Todas las escalas</option>
            <option v-for="e in escalas" :key="e" :value="e">{{ e }}</option>
          </select>

          <input
            v-model="fechaDesde"
            type="date"
            style="font-size:14px; padding:9px 12px; border-radius:8px; border:1px solid #e9ecef; color:#525f7f;"
          />
          <input
            v-model="fechaHasta"
            type="date"
            style="font-size:14px; padding:9px 12px; border-radius:8px; border:1px solid #e9ecef; color:#525f7f;"
          />
        </div>

        <div v-if="!cargando && listaFiltrada.length === 0" style="background:#fff; border:1px solid #e9ecef; border-radius:12px; padding:32px; text-align:center; color:#8898aa; font-size:14px;">
          {{ lista.length === 0 ? 'Sin auditorías registradas todavía.' : 'No hay auditorías que coincidan con el filtro.' }}
        </div>

        <div style="display:flex; flex-direction:column; gap:10px;">
          <auditoria-list-item
            v-for="auditoria in listaFiltrada"
            :key="auditoria.id"
            :auditoria="auditoria"
            @click.native="verDetalle(auditoria.id)"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import AuditoriasGateway from '@/gateways/AuditoriasGateway'
import AuditoriaListItem from './components/AuditoriaListItem'

export default {
  name: 'AuditoriasHome',
  components: { Loading, AuditoriaListItem },
  data () {
    return {
      lista: [],
      cargando: false,
      error: null,
      busqueda: '',
      tipoActivo: '',
      escalaActiva: '',
      fechaDesde: '',
      fechaHasta: '',
      escalas: ['Excelente', 'Satisfactorio', 'Aceptable', 'Deficiente']
    }
  },
  computed: {
    listaFiltrada () {
      var self = this
      var q = this.busqueda.trim().toLowerCase()
      return this.lista.filter(function (a) {
        if (q && (a.codigo || '').toLowerCase().indexOf(q) === -1) return false
        if (self.tipoActivo && a.tipo !== self.tipoActivo) return false
        if (self.escalaActiva && a.escala !== self.escalaActiva) return false

        var fecha = self.parseFecha(a.fecha)
        if (self.fechaDesde && (!fecha || fecha < self.parseFecha(self.fechaDesde))) return false
        if (self.fechaHasta && (!fecha || fecha > self.parseFecha(self.fechaHasta))) return false

        return true
      })
    }
  },
  created () {
    this.cargarLista()
  },
  methods: {
    cargarLista () {
      var self = this
      this.cargando = true
      this.error = null
      AuditoriasGateway.listar()
        .then(function (res) {
          if (!res.data.success) {
            self.error = 'No se pudo cargar el historial de auditorías. Intenta de nuevo.'
            return
          }
          self.lista = res.data.data || []
        })
        .catch(function () {
          self.error = 'No se pudo cargar el historial de auditorías. Intenta de nuevo.'
        })
        .finally(function () {
          self.cargando = false
        })
    },
    verDetalle (id) {
      this.$router.push({ name: 'auditorias-detalle', params: { id: id } })
    },
    parseFecha (fecha) {
      if (!fecha) return null
      var soloFecha = fecha.indexOf('T') === -1 ? fecha : fecha.slice(0, 10)
      var d = new Date(soloFecha + 'T00:00:00')
      return isNaN(d.getTime()) ? null : d
    }
  }
}
</script>
